export default function Copied(props) {
    return (
        props.show && <div className="fixed top-0 left-0 z-20 flex justify-center items-center min-h-screen min-w-full bg-green-600 text-8xl text-white dark:text-green-600 dark:bg-gray-900">Copied!</div>
    )
}